import { useState } from 'react'
import { Column } from 'react-table'
import { IAudit } from '../../../../../../../app/entities/Audit'
import TableTitle from '../../../../../global/components/table/helpers/table-title/TableTitle'
import TableTopper from '../../../../../global/components/table/helpers/table-topper/TableTopper'
import Table from '../../../../../global/components/table/Table'
import { useAuditConfig } from '../../../../../global/context/audit-config-context/AuditConfigContext'
import { STATUS } from '../../../../../global/types/audit'
import { formatDate } from '../../../../../global/utils/date/mm-dd-yyyy'
import getStatusForAuditSection from '../../../../utils/get-statuses-for-audit-section'
import { StatusDot } from '../../../common/StatusDot'

function CompletedInstallationTable({ audits }: { audits: IAudit[] }) {
  const SECTIONS = useAuditConfig(STATUS.COMPLETED_INSTALLATION).SECTIONS
  const [isOpen, setIsOpen] = useState(true)

  const dailyDvircolumns: Column<IAudit | any>[] = [
    {
      Header: 'Service Date',
      accessor: 'operationDate',
      Cell: ({ row: { original } }) => {
        const date = new Date(original.operationDate)
        const formattedDate = formatDate(date)
        return <>{formattedDate}</>
      },
    },
    {
      Header: 'Order ID',
      accessor: 'orderVehicle.order.workOrderId',
    },
    {
      Header: 'Pre Install Photos',
      accessor: 'preInstallPhotos',
      Cell: ({ row: { original } }) => {
        const { state } = original as IAudit
        const failure = getStatusForAuditSection(state, [
          SECTIONS.pre_install_front_driver,
          SECTIONS.pre_install_front_passenger,
          SECTIONS.pre_install_rear_driver,
          SECTIONS.pre_install_rear_passenger,
        ])
        return StatusDot(failure)
      },
    },
    {
      Header: 'Work Area Photos',
      accessor: 'workAreaPhotos',
      Cell: ({ row: { original } }) => {
        const { state } = original as IAudit
        const failure = getStatusForAuditSection(state, [
          SECTIONS.order_details_work_area,
        ])
        return StatusDot(failure)
      },
    },
    {
      Header: 'Torque Stick',
      accessor: 'torqueStick',
      Cell: ({ row: { original } }) => {
        const { state } = original as IAudit
        const failure = getStatusForAuditSection(state, [
          SECTIONS.order_details_torque_stick,
        ])
        return StatusDot(failure)
      },
    },
    {
      Header: 'Post Install Photos',
      accessor: 'postInstallPhotos',
      Cell: ({ row: { original } }) => {
        const { state } = original as IAudit
        const failure = getStatusForAuditSection(state, [
          SECTIONS.post_install_front_driver,
          SECTIONS.post_install_front_passenger,
          SECTIONS.post_install_rear_driver,
          SECTIONS.post_install_rear_passenger,
        ])
        return StatusDot(failure)
      },
    },
  ]
  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Completed Installations</TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={dailyDvircolumns}
        data={audits}
        isLoading={false}
        onRowClick={() => {}}
        isOpen={isOpen}
        isDisplayMode={true}
      />
    </div>
  )
}

export { CompletedInstallationTable }
